import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="privacy-container">
      <div className="overlay"></div>
      
      <div className="content-wrapper">
        <div className="privacy-content">
          {/* Header Section */}
          <header className="privacy-header">
            <h1>Terms and conditions</h1>
            <h2>Terms and conditions for <span className="brand-name">HomePlannner.com</span></h2>
          </header>

          {/* Main Content */}
          <main className="privacy-main">
  {/* Section 1 */}
  <section className="privacy-section">
    <h3>1. Welcome</h3>
    <p>Welcome to HomePlannner.com. By accessing or purchasing our services, you agree to the following terms.</p>
  </section>

  {/* Section 2 */}
  <section className="privacy-section">
    <h3>2. Services</h3>
    <ul>
      <li>We provide AI-generated floor plans and elevations based on user responses.</li>
      <li>Deliverables are sent digitally (PDF/JPEG/PNG) within 24 hours of payment.</li>
    </ul>
  </section>

  {/* Section 3 */}
  <section className="privacy-section">
    <h3>3. User Responsibilities</h3>
    <ul>
      <li>Provide accurate and complete project details in the questionnaire.</li>
      <li>Ensure mobile/email is valid for communication.</li>
      <li>Use the plans for personal/home construction purposes only (not resale or redistribution).</li>
    </ul>
  </section>

  {/* Section 4 */}
  <section className="privacy-section">
    <h3>4. Pricing & Payment</h3>
    <ul>
      <li>Packages: ₹299 / ₹399 / ₹599 / ₹899 (prepaid only).</li>
      <li>Payment is processed via secure third-party gateways.</li>
      <li>Prices may change without prior notice.</li>
    </ul>
  </section>

  {/* Section 5 */}
  <section className="privacy-section">
    <h3>5. Revisions</h3>
    <ul>
      <li>Minor corrections (typos, labeling issues) may be done free once.</li>
      <li>Major redesigns (new dimensions, layouts) require a new purchase.</li>
    </ul>
  </section>

  {/* Section 6 */}
  <section className="privacy-section">
    <h3>6. Intellectual Property</h3>
    <ul>
      <li>Plans are generated uniquely for you but remain the intellectual property of HomePlannner.com.</li>
      <li>You receive a non-exclusive license to use for your project.</li>
      <li>Redistribution or commercial resale is prohibited.</li>
    </ul>
  </section>

  {/* Section 7 */}
  <section className="privacy-section">
    <h3>7. Limitation of Liability</h3>
    <ul>
      <li>Our outputs are conceptual design aids, not final construction drawings.</li>
      <li>Always consult a licensed architect/engineer before execution.</li>
      <li>We are not liable for construction defects, compliance issues, or structural safety.</li>
    </ul>
  </section>

  {/* Section 8 */}
  <section className="privacy-section">
    <h3>8. Governing Law & Dispute Resolution</h3>
    <ul>
      <li>These Terms are governed by the laws of India.</li>
      <li>Any dispute arising from these Terms shall be subject to the exclusive jurisdiction of courts in Indore, Madhya Pradesh.</li>
    </ul>
  </section>
</main>

        </div>
      </div>

      <style jsx>{`
        .privacy-container {
          position: relative;
          min-height: 100vh;
          background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 800"><rect fill="%23000" width="1200" height="800"/><g fill="%23333"><circle cx="200" cy="150" r="80" opacity="0.1"/><circle cx="800" cy="300" r="120" opacity="0.05"/><circle cx="1000" cy="600" r="100" opacity="0.08"/></g></svg>') center/cover;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }
        footer {
    display: block !important;
    /* top: 0; */
    bottom: 0;
    width: 100%;
    z-index: 9999;
}
        .overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.5) 100%);
          z-index: 1;
        }

       .content-wrapper {
    position: relative;
    z-index: 2;
    width: 100%;
    max-width: 900px;
    max-height: 90vh;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: rgb(255 255 255 / 0%) transparent;
}

        .content-wrapper::-webkit-scrollbar {
          width: 6px;
        }

        .content-wrapper::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.1);
          border-radius: 3px;
        }

        .content-wrapper::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.3);
          border-radius: 3px;
        }

        .content-wrapper::-webkit-scrollbar-thumb:hover {
          background: rgba(255, 255, 255, 0.5);
        }

        .privacy-content {
          background: rgba(0, 0, 0, 0.9);
          backdrop-filter: blur(10px);
          border-radius: 16px;
          padding: 40px;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);
          border: 1px solid rgba(255, 255, 255, 0.1);
        }

        .privacy-header {
          text-align: center;
          margin-bottom: 40px;
          border-bottom: 2px solid #4a5568;
          padding-bottom: 30px;
        }

        .privacy-header h1 {
          font-size: 2.5rem;
          font-weight: 700;
          color: #ffffff;
          margin: 0 0 15px 0;
          text-shadow: 0 2px 4px rgba(255, 255, 255, 0.1);
        }

        .privacy-header h2 {
          font-size: 1.25rem;
          font-weight: 500;
          color: #a0aec0;
          margin: 0;
        }

        .brand-name {
          font-weight: 700;
          color: #2d3748;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .privacy-main {
          line-height: 1.7;
          color: #e2e8f0;
        }

        .privacy-section {
          margin-bottom: 35px;
          background: rgba(26, 32, 44, 0.6);
          border-radius: 12px;
          padding: 30px;
          border: 1px solid rgba(113, 128, 150, 0.3);
          transition: all 0.3s ease;
        }

        .privacy-section:hover {
          background: rgba(26, 32, 44, 0.8);
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
        }

        .privacy-section h3 {
          font-size: 1.5rem;
          font-weight: 600;
          color: #ffffff;
          margin: 0 0 20px 0;
          border-left: 4px solid #667eea;
          padding-left: 15px;
        }

        .privacy-section p {
          margin: 0 0 15px 0;
          font-size: 1rem;
          color: #cbd5e0;
        }

        .subsection {
          margin: 20px 0;
          padding: 20px;
          background: rgba(45, 55, 72, 0.5);
          border-radius: 8px;
          border: 1px solid rgba(113, 128, 150, 0.2);
        }

        .subsection h4 {
          font-size: 1.1rem;
          font-weight: 600;
          color: #f7fafc;
          margin: 0 0 12px 0;
        }

        ul {
          margin: 0;
          padding: 0 0 0 20px;
          list-style: none;
        }

        ul li {
          margin: 10px 0;
          padding-left: 20px;
          position: relative;
          color: #cbd5e0;
          font-size: 1rem;
        }

        ul li::before {
          content: "•";
          color: #667eea;
          font-weight: bold;
          position: absolute;
          left: 0;
          font-size: 1.2rem;
        }

        ul li:hover {
          color: #ffffff;
          transform: translateX(3px);
          transition: all 0.2s ease;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .privacy-container {
            padding: 10px;
          }

          .privacy-content {
            padding: 25px;
            margin: 10px 0;
          }

          .privacy-header h1 {
            font-size: 2rem;
          }

          .privacy-header h2 {
            font-size: 1.1rem;
          }

          .privacy-section {
            padding: 20px;
            margin-bottom: 25px;
          }

          .privacy-section h3 {
            font-size: 1.3rem;
          }

          .subsection {
            padding: 15px;
          }
        }

        @media (max-width: 480px) {
          .privacy-header h1 {
            font-size: 1.8rem;
          }

          .privacy-header h2 {
            font-size: 1rem;
          }

          .privacy-section h3 {
            font-size: 1.2rem;
          }
        }
      `}</style>
    </div>
  );
};

export default TermsAndConditions;